import { useTheme } from "../hooks/useTheme";

export function ThemeToggle() {
  const { preference, cycle } = useTheme();
  const label =
    preference === "light"
      ? "Light theme — click to switch to dark"
      : preference === "dark"
        ? "Dark theme — click to switch to system"
        : "System theme — click to switch to light";

  return (
    <button
      type="button"
      onClick={cycle}
      className="btn btn-ghost"
      aria-label={label}
      title={label}
    >
      <Icon preference={preference} />
      <span className="hidden text-xs uppercase tracking-wide md:inline">{preference}</span>
    </button>
  );
}

function Icon({ preference }: { preference: "light" | "dark" | "system" }) {
  if (preference === "light") {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2m0 16v2M2 12h2m16 0h2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41" />
      </svg>
    );
  }
  if (preference === "dark") {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    );
  }
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <rect x="3" y="4" width="18" height="14" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </svg>
  );
}
